import { Currency } from 'hydra-data-types';
import { CountryCode } from '../../helpers/GeoLocate';

/** The Country and Currency for the users geolocation. */
export type GeolocationState = {
  country: CountryCode;
  /** **This is not the user selected currency** - that would be `pricing.currency`. */
  currency: Currency;
};

/** Fallback when geolocation fails or the country is unsupported. AU protects access flows (Medicare / US 65+) from a failed lookup. */
export const INITIAL_GEOLOCATION_STATE: GeolocationState = {
  country: 'AU',
  currency: Currency.AUD,
};
